import React from 'react';

/**
 * Animated multi-color gradient text — the gradient itself pans horizontally
 * so the color composition shifts under the letters. Pure CSS keyframes, no
 * layout thrash. Respects prefers-reduced-motion (static gradient).
 */
const STYLE_ID = 'esg-aurora-text-style';
const ensureStyle = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = `
    @keyframes esg-aurora-pan {
      0%   { background-position:   0% 50%; }
      50%  { background-position: 100% 50%; }
      100% { background-position:   0% 50%; }
    }
    .esg-aurora {
      background-image: linear-gradient(90deg, #3b82f6 0%, #06b6d4 25%, #10b981 50%, #06b6d4 75%, #3b82f6 100%);
      background-size: 200% 100%;
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      animation: esg-aurora-pan 8s ease-in-out infinite;
    }
    @media (prefers-reduced-motion: reduce) {
      .esg-aurora { animation: none; background-position: 50% 50%; }
    }
  `;
  document.head.appendChild(s);
};

const AuroraText = ({ children, as: Tag = 'span', className = '', style = {} }) => {
  ensureStyle();
  return (
    <Tag className={`esg-aurora ${className}`} style={style}>
      {children}
    </Tag>
  );
};

export default AuroraText;
